import {StockInformationModel} from "../domain/stockInformationModel";

type InTransitModelType = Pick<StockInformationModel, "inTransitDays">;

export class InTransitModel {
    private _model: InTransitModelType;

    constructor(model: InTransitModelType) {
        this._model = model;
    }

    get title() {
        return `In stock in ${this._model.inTransitDays} day${
            this._model.inTransitDays > 1 ? "s" : ""
        }`;
    }

    get subtitle() {
        return ` This item is currently backordered and is expected to ship in approx. ${
            this._model.inTransitDays
        } day(${this._model.inTransitDays > 1 ? "s" : ""}`;
    }

    static create(model: StockInformationModel) {
        return new InTransitModel(model);
    }
}
